import { memo, useEffect, useState, useContext } from "react";
import { langWrapper } from "../../../../Localization";
import LanguageMessage from "../../../LanguageMessage/LanguageMessage";
import "./LightPoint.css";
const LightPoint = ({ step, stepData }) => {
  const { lang, setLang } = useContext(langWrapper);

  const [positions, setPositions] = useState({});
  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById(stepData[step]);
      const parent = document.getElementById("menu-list-container");
      if (step < 6) parent.scrollTop = 0;
      else element.scrollIntoView();
      const rect = element.getBoundingClientRect();
      setPositions(rect);
    });
  }, [step, stepData, lang]);
  return (
    <section
      className={`LightPoint ${
        step === 1 && "clickable"
      } position-fixed transition rounded-3`}
      style={{
        width: positions.width,
        height: positions.height,
        left: positions.left,
        top: positions.top,
      }}
    >
      <div
        className="scale-up position-absolute w-100 h-100 rounded-3"
        onClick={(event) => {
          event.target === event.currentTarget &&
            step === 1 &&
            setLang(lang === "fa" ? "en" : "fa");
        }}
      />
      <div
        className="point position-absolute bg-primary text-center rounded-3"
        style={{
          top: step < 7 && positions.height,
          bottom: step >= 7 && positions.height,

          right:
            step === 1
              ? lang === "en" && positions.width
              : lang === "fa" && positions.width,
          left:
            step === 1
              ? lang === "fa" && positions.width
              : lang === "en" && positions.width,
        }}
      >
        <h3>
          <LanguageMessage message={stepData[step]} />
        </h3>
        <LanguageMessage message={`guide-${stepData[step]}`} />
      </div>
    </section>
  );
};
export default memo(LightPoint);
